export const PXPostsCarousel = (function () {
	'use strict';

	let $carousels;

	function init() {
		events();
	}

	function events() {
		$carousels = $('.posts-carousel');
		if (!$carousels.length > 0) return null;

		// console.log($carousels);

		$carousels.each(function () {
			let $this = $(this);
			const $parent = $this.parent().parent().parent().parent().parent();
			const $isCompact = $parent.hasClass('layout--compact');

			// console.log($this);

			if (!$this.hasClass('slick-initialized')) {
				if ($isCompact) {
					$this.slick({
						arrows: true,
						dots: false,
						infinite: false,
						speed: 300,
						slidesToShow: 2,
						// slidesToScroll: 3,
						swipeToSlide: true,
						responsive: [{
							breakpoint: 1280,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 620,
							settings: {
								slidesToShow: 1
							}
						}]
					});
				}
				else {
					$this.slick({
						arrows: true,
						dots: false,
						infinite: false,
						speed: 300,
						slidesToShow: 1.5,
						// slidesToScroll: 3,
						swipeToSlide: true,
						responsive: [{
							breakpoint: 1280,
							settings: {
								slidesToShow: 1
							}
						},
						{
							breakpoint: 620,
							settings: {
								slidesToShow: 1
							}
						}]
					});
				}
			}

		});
	}

	return {
		init: init
	};
})();